import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { propertyAttributeServices } from '../services/propertyAttribute.service';

export const useAddPropertyAttribute = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload) => propertyAttributeServices.addPropertyAttribute(payload),
    onSuccess: () => {
      queryClient.invalidateQueries(['property-attributes']);
      toast.success('Attribute created successfully');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to add attribute');
    },
  });
};
